export enum EAdjustmentType {
  all = 'all',
  yes = 'yes',
  no = 'no',
}
